<template>
  <v-content class="gb">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="12">
          <v-card
              :loading="status === 'loading' || status_action === 'loading'"
              class="fill-width table_theme card-theme custom-container"
          >
            <v-card-title>
              <span class="title_table medium-font" style="letter-spacing: normal">
                Vendors
              </span>
              <v-spacer></v-spacer>
              <v-btn rounded small dark color="#061D47"
                  style="width: 120px !important; margin-right: 8px; text-transform: none; font-weight: 600;"
                  @click="$router.push('/owner/vendor-coverage')"
              >Coverage</v-btn>
              <div style="position: relative; display: inline-block; margin-right: 8px;">
                <v-btn rounded small dark color="#5C6BC0"
                    style="width: 148px !important; text-transform: none; font-weight: 600;"
                    @click="$router.push('/owner/vendor-recommendations')"
                >Vendor Referrals</v-btn>
                <div v-if="pendingRecommendationsCount > 0"
                     style="position: absolute; top: -6px; right: -6px; background: #F44336; color: white; border-radius: 12px; min-width: 22px; height: 22px; display: flex; align-items: center; justify-content: center; font-size: 11px; font-weight: 700; padding: 0 6px; pointer-events: none;">
                  {{ pendingRecommendationsCount }}
                </div>
              </div>
              <div
                  class="custom-o-search-bar"
                  style="right: -25px !important; left: auto !important; top:0px;"
              >
                <v-text-field
                    v-model="search"
                    placeholder="Search..."
                    single-line
                    hide-details
                    class="input_search"
                    color="#198beb"
                >
                  <img
                      :src="require('@/assets/img/search.svg')"
                      slot="prepend"
                      alt="help"
                      class="info-tooltip"
                  />
                </v-text-field>
              </div>
<!--              <v-btn text class="custom-o-sliders">-->
<!--                <img :src="require('@/assets/img/settings.svg')" alt/>-->
<!--              </v-btn>-->
            </v-card-title>
            <div style="width: 100%;">
              <v-divider style="max-width: 1096px;"></v-divider>
            </div>
            <div class="status-stats-bar">
              <div class="status-stats-bar__item">
                <span class="status-stats-bar__label">Total</span>
                <span class="status-stats-bar__count">{{ statusCounts.reduce((s, i) => s + i.count, 0) }}</span>
              </div>
              <template v-if="user && user.user_role === 'super_user'">
                <div class="status-stats-bar__divider"></div>
                <div class="status-stats-bar__item" title="Unique people (deduped by owner_id) across tenants">
                  <span class="status-stats-bar__label">Unique</span>
                  <span class="status-stats-bar__count">{{ uniqueOwnerCount }}</span>
                </div>
              </template>
              <div v-if="statusCounts.length > 0" class="status-stats-bar__divider"></div>
              <template v-for="(item, index) in statusCounts">
                <div v-if="index > 0" :key="'divider-' + item.status" class="status-stats-bar__divider"></div>
                <div
                    :key="item.status"
                    class="status-stats-bar__item"
                    :class="{ 'status-stats-bar__item--active': filters.status === item.status }"
                    @click="toggleStatusFilter(item.status)"
                    style="cursor: pointer;"
                >
                  <v-icon class="status-stats-bar__dot" :style="{ color: statusColor(item.status) }">brightness_1</v-icon>
                  <span class="status-stats-bar__label">{{ item.status }}</span>
                  <span class="status-stats-bar__count">{{ item.count }}</span>
                </div>
              </template>
              <div class="status-stats-bar__actions">
                <v-btn v-if="paymentPermission" rounded text color="#29ABE2"
                    class="btn-blanco table_btn custom-o-white btn-border"
                    style="width: 149px !important;"
                    v-on:click="$router.push('/owner/vendors/add')"
                >Add New Vendor</v-btn>
                <v-btn rounded text color="#29ABE2"
                    class="btn-blanco table_btn custom-o-white btn-border"
                    style="width: 149px !important;"
                    :disabled="allSelectedInactive"
                    @click="show_DeleteModal"
                >Delete</v-btn>
                <v-btn v-if="paymentPermission" rounded text color="#29ABE2"
                    class="btn-blanco table_btn custom-o-white btn-border"
                    style="width: 149px !important;"
                    :disabled="allSelectedInactive"
                    @click="show_ResendModal"
                >Resend Invite</v-btn>
                <v-btn rounded text color="#29ABE2"
                    class="btn-blanco table_btn custom-o-white btn-border"
                    style="width: 149px !important;text-transform: none;"
                    :href="rutaExel + '&order_by='+ orderBy +'&sort_by='+ sort_by"
                    :disabled="selected.length === 0"
                >Download (excel)</v-btn>
              </div>
            </div>
            <template v-if="error">
              <div>
                <v-alert type="error" dense dismissible @input="error = false">{{ message_error }}</v-alert>
              </div>

            </template>
            <v-data-table
                v-model="selected"
                :headers="headers"
                :items="filteredItems"
                :search="search"
                :custom-filter="searchFilter"
                color="#717e91"
                :multi-sort="false"
                item-key="id"
                show-select
                :options.sync="options"
                :custom-sort="customSort"
                class="vendors-table"
            >
              <template v-slot:header.data-table-select="{ props, on }">
                <SelectCheckbox
                    :value="props.value"
                    :indeterminate="props.indeterminate"
                    @input="on.input($event)"
                />
              </template>
              <template v-slot:item.data-table-select="{ isSelected, select }">
                <SelectCheckbox
                    :value="isSelected"
                    @input="select($event)"
                />
              </template>
              <template v-slot:no-data>
                <div style="padding: 24px; text-align: center; color: #717e91; font-size: 13px;">
                  <span v-if="deletedCount > 0 && filters.status !== 'Deleted'">{{ deletedCount }} deleted user(s) are hidden — click Deleted above to view.</span>
                  <span v-else>No users found.</span>
                </div>
              </template>
              <!-- buttons moved to status-stats-bar -->
              <template v-slot:item.status="{ item }">
                                <span
                                    class="text-xs-right table-f"
                                    style="text-transform: capitalize; width:100% !important; display: inline-block !important;"
                                >
                                  <v-icon
                                      class="status-icon custom-status-icon"
                                      v-bind:style="{
                                      color: statusColor(item.status)
                                    }"
                                  >brightness_1</v-icon>
                                  {{ item.status }}
                                </span>
              </template>
              <template v-slot:item.created_at="{ item }">
                <span class="table-f" style="font-size: 12px !important;">{{ formatRegisteredDate(item.created_at) }}</span>
              </template>
              <template v-slot:item.company_name="{ item }">
                <div v-if="!item._isEmployeeRow" class="cell-truncate">
                  <span :title="item.company_name" class="text-truncate-cell">
                    {{ item.company_name }}
                  </span>
                  <div
                    v-if="employeeCounts[item.owner_id]"
                    class="employee-expand-toggle"
                    @click.stop="toggleVendorExpand(item.owner_id)"
                  >
                    <span v-if="!expandedVendors.includes(item.owner_id)">+{{ employeeCounts[item.owner_id] }}</span>
                    <span v-else>-{{ employeeCounts[item.owner_id] }}</span>
                  </div>
                </div>
                <span v-else class="employee-indent"></span>
              </template>
              <template v-slot:item.name="{ item }">
                <span :title="item.name" class="text-truncate-cell">
                  {{ item.name }}
                </span>
              </template>
              <template v-slot:item.email="{ item }">
                <span :title="item.email" class="text-truncate-cell">{{ item.email }}</span>
              </template>
              <template v-slot:item.phone="{ item }">
                <span>{{ item.phone }}</span>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                    depressed
                    @click="openEditModal(item)"
                    style="padding: 0; font-size: 11px; height: 24px; min-width: 44px; color: #061D47; border: 1px solid #061D47;"
                >Edit
                </v-btn>
              </template>
              <template v-slot:item.service="{ item }">
                <span class="text-truncate-cell" :title="item.service === '' ? item.service_other : item.service">{{item.service === '' ? item.service_other : item.service}}</span>
              </template>
              <template v-slot:item.active_clients="{ item }">
                <div style="text-align: center;">
                  <a
                    v-if="item.active_clients > 0"
                    href="#"
                    @click.prevent="showConnections(item)"
                    style="color: #29ABE2; text-decoration: none; cursor: pointer;"
                  >{{ item.active_clients }}</a>
                  <span v-else>{{ item.active_clients }}</span>
                </div>
              </template>
              <template v-slot:item.isAdmin="{ item }">
                <span class="group table-f">{{ item.isAdmin ? "Yes" : "No" }}</span>
              </template>
              <template v-slot:header.notifications="{ header }">
                <span style="cursor: pointer; user-select: none;" @click="toggleAlertsFilter" :title="filters.alerts === null ? 'Click to filter alerts' : filters.alerts ? 'Showing: Alerts ON (click for OFF)' : 'Showing: Alerts OFF (click to clear)'">
                  {{ header.text }}
                  <v-icon x-small v-if="filters.alerts === true" color="#2e7d32">notifications_active</v-icon>
                  <v-icon x-small v-if="filters.alerts === false" color="#b0bec5">notifications_off</v-icon>
                </span>
              </template>
              <template v-slot:item.notifications="{ item }">
                <div style="text-align: center;">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon small v-bind="attrs" v-on="on" :color="notificationStatusDisplay(item).color">
                        {{ notificationStatusDisplay(item).icon }}
                      </v-icon>
                    </template>
                    <span>{{ notificationStatusDisplay(item).label }}</span>
                  </v-tooltip>
                </div>
              </template>
              <template v-slot:item.messagesReceived="{ item }">
                <div style="text-align: center;">{{ item.messagesReceived }}</div>
              </template>
              <template v-slot:item.messagesSent="{ item }">
                <div style="text-align: center;">{{ item.messagesSent }}</div>
              </template>
              <template v-slot:item.is_admin="{ item }">
                <div class="admin-cell">
                  <v-simple-checkbox
                      :value="item.is_admin"
                      @input="switch_admin(item)"
                      color="primary"
                      :ripple="false"
                  ></v-simple-checkbox>
                  <v-tooltip v-if="item.user_role === 'vendor' || item._isEmployeeRow" top content-class="compact-tooltip" nudge-top="-4">
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="admin-role-label" v-if="item.user_role === 'vendor'">O</span>
                      <span v-on="on" class="admin-role-label" v-else-if="item._isEmployeeRow">E</span>
                    </template>
                    <span>{{ item._isEmployeeRow ? 'Employee' : 'Owner' }}</span>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>
            <div style="width: 100%;">
              <v-divider style="max-width: 1096px;"></v-divider>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <delete-modal
          :selected="selected"
          :show="showDeleteModal"
          :hide="hideDeleteModal"
          @setter="setter"
      />
      <DeleteAllModal
          :show="showDeleteAllModal"
          :hide="hideDeleteAllModal"
      />
      <resend-modal :show="showResendModal" :hide="hideResendModal" :results="resendResults"/>
      <connections-modal
          ref="connectionsModal"
          :title="connectionsUser ? 'Active Homeowners - ' + connectionsUser.name : ''"
          :referrals="parsedReferrals"
          :ownerId="connectionsUser ? connectionsUser.owner_id : ''"
      />
      <edit-user-modal
          :show="showEditModal"
          :user="selectedUser"
          :hide="closeEditModal"
      />
    </v-container>
  </v-content>
</template>

<style scoped lang="scss">
  .modal-content {
    max-width: 530px;
  }

  .custom-select-margin {
    margin-top: -10px;
  }

  .custom-container {
    top: 40px;
    max-width: 1222px !important;
    min-height: 558px;
    margin-bottom: 50px !important;
    padding-bottom: 80px;
  }

  .custom-o-white {
    height: 32px !important;
    width: 149px !important;
    top: 2px;
  }

  .table_btn {
    color: #2bace2;
    font-size: 13px;
    font-weight: 400;
    text-transform: capitalize;
    letter-spacing: normal;
  }

  .table_botonera {
    padding: 15px 16px 20px;
    position: relative;
  }

  .fill-width .mar_table {
    margin: 0 13px;
  }

  .drop-down-company {
    display: inline-block;
    width: 110px;
    margin-right: 27px;
    position: relative;
    top: 8px;
    left: -3px;
    color: #2bace2 !important;
  }

  .admin-cell {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .admin-role-label {
    position: absolute;
    left: calc(50% + 14px);
    font-size: 11px;
    font-weight: 600;
    color: #979797;
    cursor: default;
  }
</style>

<script>
  import deleteModal from "./modals/delete";
  import DeleteAllModal from "@/views//modals/delete-all";
  import connectionsModal from "@/views/modals/connections";
  import resendModal from "./modals/resend";
  import EditUserModal from "@/views/owner/modals/EditUserModal";
  import {mapState, mapActions} from "vuex";
  import config from "@/config/constants.js";
  import {notificationStatusDisplay} from '@/util/notification_status';
  import {mask} from "vue-the-mask";
  import PaymentMixin from '@/mixins/payment';
  import SelectCheckbox from '@/components/SelectCheckbox.vue';

  let token = localStorage.getItem("auth_token");
  import {firestore} from "@/config/firebase";

  export default {
    name: "vendorsList",
    mixins: [PaymentMixin],
    created() {
      this._isDestroyed = false;
      if (this.$store.getters["Authenticate/isLoggedIn"]) {
        const prevRole = this.$store.state.Users_list.userRole;
        if (prevRole && prevRole !== 'vendor') {
          this.$store.dispatch('Users_list/clear_data');
        }
        this.$store.dispatch("Users_list/get_tenant", "vendor").then(response => {
          if (this._isDestroyed) return;
          if (response === 'success') {
            const usersPromise = this.get_users("vendor");
            this.prefetchReferrals();
            usersPromise.then(() => {
              if (this._isDestroyed) return;
              this.recalcActiveClients();
            });
          }
        });
        this.$store.dispatch("Referral_engine/fetchRecommendations", "pending");
      } else {
        this.$router.push("/owner/sign_up");
      }
    },
    directives: {
      mask,
    },
    computed: {
      ...mapState({
        status: (state) => state.Users_list.status,
        status_action: (state) => state.Users_list.status_action,
        totals: (state) => state.Users_list.totals,
        dataUsers: (state) => state.Users_list.dataUsers,
        dataCompanies: (state) => state.Users_list.dataCompanies,
        user: (state) => state.Authenticate.user,
        services: (state) => state.Users_list.services,
        pendingRecommendationsCount: (state) => {
          const recs = (state.Referral_engine && state.Referral_engine.recommendations) || [];
          return recs.filter(r => r.status === 'pending').length;
        },
      }),
      selectedUser() {
        if (!this.selectedUserId) return {};
        return this.dataUsers.find(u => u.owner_id === this.selectedUserId) || {};
      },
      employeeCounts() {
        const counts = {};
        for (const user of this.dataUsers) {
          if (user.user_role === 'employee' && user.vendor_id) {
            counts[user.vendor_id] = (counts[user.vendor_id] || 0) + 1;
          }
        }
        return counts;
      },
      filteredItems() {
        const STATUS_ORDER = { active: 0, onboarding: 1, "signed up": 2, invited: 3, inactive: 4, cancelled: 5, deleted: 6 };
        let vendors;
        if (!this.filters.status) {
          vendors = this.dataUsers.filter(x => x.user_role === "vendor" && (x.status || '').toLowerCase() !== 'deleted');
        } else {
          vendors = this.dataUsers.filter(x => this.filters.status.toLowerCase() === (x.status || '').toLowerCase() && x.user_role === "vendor");
        }
        if (this.company_data && this.company_data.toLowerCase() !== 'all') {
          vendors = vendors.filter(x => (x.company_name || '').toLowerCase() === this.company_data.toLowerCase());
        }
        if (this.filters.alerts !== null) {
          vendors = vendors.filter(x => {
            const hasAlerts = x.device_tokens && x.device_tokens.length > 0;
            return this.filters.alerts ? hasAlerts : !hasAlerts;
          });
        }
        // Default sort by status (Active first) when no column sort is active
        if (!this.options.sortBy || this.options.sortBy.length === 0) {
          vendors = [...vendors].sort((a, b) => {
            const aOrder = STATUS_ORDER[(a.status || "").toLowerCase()] ?? Infinity;
            const bOrder = STATUS_ORDER[(b.status || "").toLowerCase()] ?? Infinity;
            if (aOrder !== bOrder) return aOrder - bOrder;
            const aName = (a.company_name || "").toLowerCase();
            const bName = (b.company_name || "").toLowerCase();
            return aName < bName ? -1 : aName > bName ? 1 : 0;
          });
        }
        // Build employee lookup map once instead of filtering per vendor
        const employeesByVendor = {};
        if (this.expandedVendors.length > 0) {
          for (const u of this.dataUsers) {
            if (u.user_role === 'employee' && u.vendor_id) {
              const empStatus = (u.status || '').toLowerCase();
              if (!this.filters.status) {
                if (empStatus === 'deleted') continue;
              } else if (this.filters.status.toLowerCase() !== empStatus) {
                continue;
              }
              if (!employeesByVendor[u.vendor_id]) employeesByVendor[u.vendor_id] = [];
              employeesByVendor[u.vendor_id].push(u);
            }
          }
        }
        const result = [];
        for (const vendor of vendors) {
          result.push(vendor);
          if (this.expandedVendors.includes(vendor.owner_id)) {
            const employees = employeesByVendor[vendor.owner_id] || [];
            for (const emp of employees) {
              result.push({ ...emp, _isEmployeeRow: true, _parentVendorId: vendor.owner_id });
            }
          }
        }
        return result;
      },
      statusCounts() {
        const PREFERRED_ORDER = ['Active', 'Onboarding', 'Invited', 'Deleted', 'Cancelled'];
        const counts = {};
        for (const user of this.dataUsers.filter(x => x.user_role === "vendor")) {
          if (user.status) counts[user.status] = (counts[user.status] || 0) + 1;
        }
        const ordered = PREFERRED_ORDER.filter(s => counts[s]);
        const extra = Object.keys(counts).filter(s => !PREFERRED_ORDER.includes(s));
        return [...ordered, ...extra].map(s => ({ status: s, count: counts[s] }));
      },
      uniqueOwnerCount() {
        const ids = new Set();
        for (const u of this.dataUsers.filter(x => x.user_role === "vendor")) {
          if (u.owner_id) ids.add(u.owner_id);
        }
        return ids.size;
      },
      allSelectedInactive() {
        return this.selected.length === 0 || this.selected.every(u => ['Deleted', 'Cancelled'].includes(u.status));
      },
      deletedCount() {
        return this.dataUsers.filter(u => u.user_role === 'vendor' && (u.status || '').toLowerCase() === 'deleted').length;
      }
    },
    components: {
      "delete-modal": deleteModal,
      "resend-modal": resendModal,
      "connections-modal": connectionsModal,
      "edit-user-modal": EditUserModal,
      DeleteAllModal,
      SelectCheckbox
    },
    watch: {
      selected(val) {
        const self = this;
        let usersSize = self.dataUsers.length;
        if (val.length > 0) {
          if (val.length === usersSize) {
            self.rutaExel = config.api_url + "download_exel?user_role=vendor&token=" + token + "&users=all";
          } else {
            let usersIds = val.map(function (user) {
              return user.owner_id;
            })
            self.rutaExel = config.api_url + "download_exel?user_role=vendor&token=" + token + "&users=" + usersIds;
          }
        } else {
          self.rutaExel = config.api_url + "download_exel?user_role=vendor&token=" + token;
        }
      }
    },
    data() {
      return {
        expandedVendors: [],
        filters: {
          status: "",
          alerts: null,  // null = no filter, true = alerts on, false = alerts off
        },
        statuses: [
          {id: "", name: "All Users"},
          {id: "active", name: "Active Users"},
          {id: "onboarding", name: "Onboarding Users"},
          {id: "invited", name: "Invited Users"},
          {id: "deleted", name: "Deleted Users"},
          {id: "cancelled", name: "Cancelled Users"}
        ],
        options: {
          itemsPerPage: 25,
          sortBy: [],
          sortDesc: []
        },
        selected: [],
        showDeleteModal: false,
        showDeleteAllModal: false,
        showResendModal: false,
        resendResults: [],
        valid: false,
        types: [],
        search: "",
        singleSelect: true,
        rutaExel:
          config.api_url +
          "download_exel?user_role=vendor&token=" + token,
        company_data: null,
        headers: [
          {text: "COMPANY", value: "company_name", sortable: true},
          {text: "NAME", value: "name", sortable: true},
          {text: "EMAIL", value: "email", sortable: true},
          {text: "PHONE", value: "phone", sortable: true, width: '150px'},
          {text: "STATUS", value: "status", sortable: true, width: '90px'},
          {text: "REGISTERED", value: "created_at", sortable: true, width: '90px'},
          {text: "SERVICE", value: "service", sortable: true},
          {text: "USERS", value: "active_clients", sortable: true, width: '60px', align: 'center', cellClass: 'col-center'},
          {text: "ALERTS", value: "notifications", sortable: true, width: '60px', align: 'center', cellClass: 'col-center'},
          {text: "IN", value: "messagesReceived", sortable: true, width: '50px', align: 'center', cellClass: 'col-center'},
          {text: "OUT", value: "messagesSent", sortable: true, width: '50px', align: 'center', cellClass: 'col-center'},
          {text: "ADMIN", value: "is_admin", sortable: true, width: '60px', align: 'center', cellClass: 'col-center'},
          {text: "ACTIONS", value: "actions", sortable: false, width: '70px', align: 'center', cellClass: 'col-center'}
        ],
        sort_desc: true,
        orderBy: null,
        sort_by: null,
        mask: "### - ### - ####",
        error: false,
        message_error: null,
        list_agents: [],
        connectionsUser: null,
        parsedReferrals: [],
        showEditModal: false,
        selectedUserId: null,
      };
    },
    methods: {
      notificationStatusDisplay,
      toggleAlertsFilter() {
        if (this.filters.alerts === null) {
          this.filters.alerts = true;  // Show alerts ON
        } else if (this.filters.alerts === true) {
          this.filters.alerts = false; // Show alerts OFF
        } else {
          this.filters.alerts = null;  // Clear filter
        }
      },
      toggleStatusFilter(status) {
        this.filters.status = this.filters.status === status ? "" : status;
      },
      prefetchReferrals() {
        if (this.$store.state.Users_list.referralsCache) return;
        const tenantId = this.user.tenant_id;
        firestore
          .collection('tenants').doc(tenantId)
          .collection('referrals')
          .get()
          .then(snapshot => {
            this.$store.state.Users_list.referralsCache = snapshot.docs;
          });
      },
      async recalcActiveClients() {
        const tenantId = this.user.tenant_id;
        let docs;
        if (this.$store.state.Users_list.referralsCache) {
          docs = this.$store.state.Users_list.referralsCache;
        } else {
          const snapshot = await firestore
            .collection('tenants').doc(tenantId)
            .collection('referrals')
            .get();
          docs = snapshot.docs;
          this.$store.state.Users_list.referralsCache = docs;
          if (this._isDestroyed) return;
        }
        if (this._isDestroyed) return;
        // Build vendor lookup from dataUsers (only vendors/employees are loaded on this page)
        const vendorLookup = {};
        for (const u of this.dataUsers) {
          if (['vendor', 'employee'].includes(u.user_role)) {
            vendorLookup[u.owner_id] = u;
          }
        }
        const parsed = [];
        const referralCountByVendor = {};
        for (const doc of docs) {
          const data = doc.data();
          const ids = (data.participant_ids || []).map(p => p.split('/')[4]).filter(Boolean);
          const participants = Array.isArray(data.participants) ? data.participants : [];
          let vendorId = '';
          let vendorName = '';
          let clientId = '';
          let clientName = '';
          for (const uid of ids) {
            if (vendorLookup[uid]) {
              vendorId = uid;
              const v = vendorLookup[uid];
              vendorName = v.company_name || v.name || ((v.first_name || '') + ' ' + (v.last_name || '')).trim() || 'Unknown';
            } else {
              // The other participant is the client
              clientId = uid;
              const cp = participants.find(p => p.user_id === uid);
              clientName = cp ? (cp.first_name + ' ' + cp.last_name) : 'Unknown';
            }
          }
          if (vendorId && clientId) {
            referralCountByVendor[vendorId] = (referralCountByVendor[vendorId] || 0) + 1;
            parsed.push({
              vendorId, vendorName: vendorName || 'Unknown',
              clientId, clientName: clientName || 'Unknown',
              created_at: data.created_at, is_read: data.is_read,
              ai_generated: data.ai_generated === true
            });
          }
        }
        this.parsedReferrals = parsed;
        // active_clients now represents total referral count — matches the number
        // of rows shown inside the vendor's Connections modal.
        for (const user of this.dataUsers) {
          if (user.user_role === 'vendor') {
            user.active_clients = referralCountByVendor[user.owner_id] || 0;
          }
        }
        // Single reactivity trigger to refresh computed properties
        this.$store.commit('Users_list/refreshDataUsers');
      },
      showConnections(item) {
        this.connectionsUser = item;
        this.$nextTick(() => this.$refs.connectionsModal.open());
      },
      formatRegisteredDate(timestamp) {
        if (!timestamp) return '';
        const d = new Date(timestamp);
        const m = d.getMonth() + 1;
        const day = String(d.getDate()).padStart(2, '0');
        const y = String(d.getFullYear()).slice(-2);
        return `${m}/${day}/${y}`;
      },
      statusColor(status) {
        let color = "";
        switch (status) {
          case "Active": {
            color = "#12d120";
            break;
          }
          case "Invited":
          case "Deleted":
          case "Cancelled":
          case "Onboarding":
          case "Inactive": {
            color = "#717e91";
            break;
          }
        }
        return color;
      },
      switch_admin(user) {
        this.$store.dispatch("Users_list/switch_admin", user);
      },
      setter() {
        const self = this;
        self.selected = [];
      },
      resetService(item) {
        item.service = null;
        item.service_other = "";

        this.$store.dispatch("Users_list/switch_service", {
          id: item.id,
          value: this.services[0].value,
        });
      },
      service_changed(item, service) {
        if (service !== "") {
          this.$store.dispatch("Users_list/switch_service", {
            id: item,
            value: service,
          });
        }

      },
      searchFilter(value, search, item) {
        if (!search) return true;
        const s = search.toLowerCase();
        if (item._isEmployeeRow) {
          const vendor = this.dataUsers.find(x => x.user_role === 'vendor' && x.owner_id === item._parentVendorId);
          if (vendor) {
            const vendorStr = [vendor.company_name, vendor.name, vendor.email, vendor.phone].join(' ').toLowerCase();
            if (vendorStr.includes(s)) return true;
          }
        }
        const itemStr = [item.company_name, item.name, item.email, item.phone, item.service, item.service_other, item.status].join(' ').toLowerCase();
        return itemStr.includes(s);
      },
      toggleVendorExpand(vendorOwnerId) {
        const idx = this.expandedVendors.indexOf(vendorOwnerId);
        if (idx === -1) {
          this.expandedVendors.push(vendorOwnerId);
        } else {
          this.expandedVendors.splice(idx, 1);
        }
      },
      ...mapActions({
        get_users: "Users_list/get_users",
      }),
      show_DeleteModal() {
        if (this.selected.length === this.dataUsers.filter(x => x.user_role === 'vendor').length) {
          this.showDeleteAllModal = true;
        } else {
          this.showDeleteModal = true;
        }
      },
      hideDeleteAllModal() {
        this.showDeleteAllModal = false;
      },
      hideDeleteModal() {
        this.showDeleteModal = false;
      },
      show_ResendModal() {
        const self = this;
        self.$store
          .dispatch("Users_list/resend_invite", {
            users: self.selected,
            type: "_vendor"
          })
          .then(results => {
            self.resendResults = Array.isArray(results) ? results : [];
            self.showResendModal = true;
          });
      },
      hideResendModal() {
        this.showResendModal = false;
      },
      get_excel(user_role) {
        const self = this;
        self.$store
          .dispatch("Users_list/download", user_role);
      },
      customSort(items, index, isDescending) {
        this.orderBy = index[0];
        this.sort_by = (isDescending[0]) ? 'desc' : 'asc';

        const STATUS_ORDER = { active: 0, onboarding: 1, "signed up": 2, invited: 3, inactive: 4, cancelled: 5, deleted: 6 };

        // Firestore Timestamps stringify to "[object Object]"; route them through
        // their numeric ms value so the first sort click actually orders them.
        const toMillisOrNull = (v) => {
          if (v == null) return null;
          if (typeof v.toMillis === 'function') return v.toMillis();
          if (v instanceof Date) return v.getTime();
          if (typeof v === 'object' && typeof v.seconds === 'number') return v.seconds * 1000 + Math.floor((v.nanoseconds || 0) / 1e6);
          return null;
        };

        const vendors = items.filter(x => !x._isEmployeeRow);
        const employeesByVendor = {};
        for (const item of items) {
          if (item._isEmployeeRow) {
            if (!employeesByVendor[item._parentVendorId]) employeesByVendor[item._parentVendorId] = [];
            employeesByVendor[item._parentVendorId].push(item);
          }
        }

        vendors.sort((a, b) => {
          const col = index[0];
          if (col === "status") {
            const aOrder = STATUS_ORDER[(a.status || "").toLowerCase()] ?? Infinity;
            const bOrder = STATUS_ORDER[(b.status || "").toLowerCase()] ?? Infinity;
            if (aOrder !== bOrder) return isDescending[0] ? aOrder - bOrder : bOrder - aOrder;
            const aCompany = (a.company_name || "").toLowerCase();
            const bCompany = (b.company_name || "").toLowerCase();
            if (aCompany !== bCompany) return aCompany < bCompany ? -1 : 1;
            const aName = (a.name || "").toLowerCase();
            const bName = (b.name || "").toLowerCase();
            return aName < bName ? -1 : aName > bName ? 1 : 0;
          }
          // Generic sort for all other columns
          let aVal = a[col] ?? '';
          let bVal = b[col] ?? '';
          const aMs = toMillisOrNull(aVal);
          const bMs = toMillisOrNull(bVal);
          if (aMs !== null || bMs !== null) {
            const aN = aMs ?? -Infinity;
            const bN = bMs ?? -Infinity;
            if (aN === bN) return 0;
            return isDescending[0] ? (aN < bN ? 1 : -1) : (aN < bN ? -1 : 1);
          }
          if (typeof aVal === 'number' || typeof bVal === 'number') {
            aVal = Number(aVal) || 0;
            bVal = Number(bVal) || 0;
          } else {
            aVal = String(aVal).toLowerCase();
            bVal = String(bVal).toLowerCase();
          }
          if (aVal === bVal) return 0;
          if (isDescending[0]) {
            return aVal < bVal ? 1 : -1;
          } else {
            return aVal < bVal ? -1 : 1;
          }
        });

        const result = [];
        for (const vendor of vendors) {
          result.push(vendor);
          if (employeesByVendor[vendor.owner_id]) {
            result.push(...employeesByVendor[vendor.owner_id]);
          }
        }
        return result;
      },
      openEditModal(item) {
        this.selectedUserId = item.owner_id;
        this.showEditModal = true;
      },
      closeEditModal() {
        this.showEditModal = false;
      },
    },
    beforeDestroy() {
      this._isDestroyed = true;
    }
  };
</script>

<style lang="scss">
  .status-stats-bar {
    display: flex;
    align-items: center;
    padding: 10px 24px;
    margin-bottom: 8px;
    background-color: #f8f9fb;
    border-bottom: 1px solid #e8ebef;

    &__divider {
      width: 1px;
      height: 20px;
      background-color: #d0d5dd;
      margin: 0 20px;
      flex-shrink: 0;
    }

    &__item {
      display: flex;
      align-items: center;
      gap: 6px;
    }

    &__item--active {
      background: #E3F2FD;
      border-radius: 6px;
      padding: 2px 8px;
    }

    &__dot {
      font-size: 8px !important;
    }

    &__label {
      color: #717e91;
      font-size: 13px;
      font-weight: 500;
    }

    &__count {
      color: #29ABE2;
      font-size: 13px;
      font-weight: 600;
    }

    &__actions {
      margin-left: auto;
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  .input_field_phone_number {
    padding: 0;
  }

  .employee-expand-toggle {
    color: #29ABE2;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    line-height: 1.2;
    user-select: none;

    &:hover {
      text-decoration: underline;
    }
  }

  .employee-role {
    color: #717e91 !important;
  }
</style>

<style lang="scss">
  .vendors-table {
    .v-data-footer { border-top: none !important; }

    table {
      max-width: 1096px;
      table-layout: fixed;
      width: 100%;
    }

    thead tr th {
      height: 48px !important;
      font-size: 11px !important;
      font-weight: 700 !important;
      text-transform: uppercase;
      font-family: Roboto, sans-serif !important;
      color: #979797 !important;
      white-space: nowrap;
      border-bottom: none !important;
      padding: 0 8px !important;

      .v-data-table-header__icon {
        color: #29ABE2 !important;
        margin-left: 2px;
        font-size: 14px !important;
        opacity: 0 !important;
        display: inline-block !important;
        vertical-align: middle;
      }

      &.active .v-data-table-header__icon {
        opacity: 1 !important;
      }

      span {
        position: static !important;
        top: auto !important;
        padding-right: 0 !important;
        line-height: normal !important;
        display: inline !important;
      }
    }

    tbody tr {
      box-shadow: inset 0 1px 0 rgba(0,0,0,0.08) !important;

      td {
        height: 48px !important;
        font-size: 13px;
        font-weight: 400;
        padding: 0 8px !important;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

      }
    }

    th.text-center {
      text-align: center !important;
    }
    td.col-center {
      text-align: center !important;
      overflow: visible !important;
    }

    th:first-child, td:first-child {
      width: 48px !important;
      max-width: 48px !important;
    }
  }

  .text-truncate-cell {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

</style>
